import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const CardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.25rem;
  border: 1px solid ${(p) => p.theme.colors.border2};
  border-radius: 0.75rem;
  background-color: ${(p) => p.theme.colors.background};
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
`;

export const CardMetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  flex-wrap: wrap;
`;

export const TargetUrlText = styled.code`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  background-color: ${(p) => p.theme.colors.background3};
  font-family: "SF Mono", Consolas, "Courier New", Courier, monospace;
  font-size: ${(p) => p.theme.text.fontSizes.m};
  color: ${(p) => p.theme.text.colors.primary};
`;

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
`;

// A raw value (like a header name), not a category - same code-styled
// language as TargetUrlText, just smaller and more subdued so it doesn't
// compete visually with the eventTypes chips.
export const HeaderNameTag = styled.code`
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  background-color: ${(p) => p.theme.colors.background3};
  font-family: "SF Mono", Consolas, "Courier New", Courier, monospace;
  font-size: ${(p) => p.theme.text.fontSizes.s};
  color: ${(p) => p.theme.text.colors.secondary};
`;

export const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding-top: 0.625rem;
  border-top: 1px solid ${(p) => p.theme.colors.border2};
`;

export const CardFooterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  ${(p) => p.theme.media.mobileDown} {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 3rem 2rem;
  border: 1px solid ${(p) => p.theme.colors.border2};
  border-radius: 0.75rem;
  text-align: center;
`;

export const EmptyStateIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.5rem;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.background5};
  color: ${(p) => p.theme.text.colors.brand};
`;

export const EmptyStateDescription = styled(Typography)`
  max-width: 24rem;
`;
